__turbopack_context__.v({
  "active": "NavQuickLinkStoriesItem-module-scss-module__rn6PKG__active",
  "img": "NavQuickLinkStoriesItem-module-scss-module__rn6PKG__img",
  "imgBox": "NavQuickLinkStoriesItem-module-scss-module__rn6PKG__imgBox",
  "label": "NavQuickLinkStoriesItem-module-scss-module__rn6PKG__label",
  "topLabel": "NavQuickLinkStoriesItem-module-scss-module__rn6PKG__topLabel",
  "wrapper": "NavQuickLinkStoriesItem-module-scss-module__rn6PKG__wrapper",
});
